import { Instagram, Phone, MessageCircle, MapPin } from "lucide-react";
import { BUSINESS, SERVICES } from "../data";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="main-footer"
      className="bg-[#0A0C10] border-t border-white/5 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14 border-b border-white/5">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-6">
              <div className="relative h-9 w-9 rounded-sm bg-[#00F0FF] grid place-items-center">
                <span className="font-heading text-[#0A0C10] font-bold text-lg leading-none">
                  A
                </span>
              </div>
              <div className="font-heading text-xl text-white font-semibold tracking-tight">
                AutoTech UK
              </div>
            </div>
            <p className="text-[#9CA3AF] leading-relaxed max-w-md text-sm">
              London's specialist auto electrician & car coding studio.
              Wireless CarPlay, digital dashes, ambient lighting, trackers,
              security and bespoke retrofits. Fully mobile, fully insured.
            </p>

            <div className="mt-8 flex gap-3">
              <a
                href={BUSINESS.whatsappText}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="h-10 w-10 rounded-sm bg-white/5 border border-white/10 hover:bg-[#00F0FF] hover:text-[#0A0C10] text-white grid place-items-center transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle className="h-4 w-4" />
              </a>
              <a
                href={BUSINESS.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="h-10 w-10 rounded-sm bg-white/5 border border-white/10 hover:bg-[#00F0FF] hover:text-[#0A0C10] text-white grid place-items-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href={BUSINESS.phoneHref}
                data-testid="footer-phone"
                className="h-10 w-10 rounded-sm bg-white/5 border border-white/10 hover:bg-[#00F0FF] hover:text-[#0A0C10] text-white grid place-items-center transition-colors"
                aria-label="Call"
              >
                <Phone className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.22em] text-white/50 mb-5">
              Popular services
            </div>
            <ul className="grid grid-cols-1 gap-3">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <a
                    href="#services"
                    className="text-sm text-white/80 hover:text-[#00F0FF] transition-colors"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.22em] text-white/50 mb-5">
              Contact
            </div>
            <ul className="space-y-4 text-sm text-white/80">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 text-[#00F0FF] mt-0.5" />
                <a
                  href={BUSINESS.phoneHref}
                  className="hover:text-[#00F0FF] transition-colors"
                >
                  {BUSINESS.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Instagram className="h-4 w-4 text-[#00F0FF] mt-0.5" />
                <a
                  href={BUSINESS.instagram}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-[#00F0FF] transition-colors"
                >
                  {BUSINESS.instagramHandle}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-[#00F0FF] mt-0.5" />
                <span>{BUSINESS.location}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/40">
          <div>© {year} AutoTech UK. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <span>Crypto accepted</span>
            <span>·</span>
            <span>Interest-free finance</span>
            <span>·</span>
            <span>Fully insured</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
